import React, { memo, useCallback, useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Slide, Typography } from '@material-ui/core';
import { useStyles } from './button-acompanhar-pedido-styles';
import { PedidoModel } from 'api/cardapio/models/pedido/pedido';
import { ContinuarIcon } from 'components/icons/continuar-icon';
import { useHistory } from 'react-router-dom';
import { usePedidos } from 'services/providers/pedidos-provider';
import { EnumStatusPedido } from 'api/cardapio/models/pedido/efetuar-pedido';
import { useAcompanharPedidoStore } from 'services/store/acompanhar-pedido';

type Props = {
  empresaId: string
}

export const ButtonAcompanharPedido = memo((props: Props) => {
  const { empresaId } = props;
  const classes = useStyles();
  const { getPedidoAtual } = usePedidos()
  const [mostrarButton, setMostrarButton] = useState(false);
  const [pedidoAtual, setPedidoAtual] = useState<PedidoModel | null>(null);
  const history = useHistory()
  const removerPedido = useAcompanharPedidoStore((state) => state.removerPedido)

  const handleGetPedidoAtual = useCallback(async () => {
    const pedido = await getPedidoAtual();
    if (pedido) {
      setPedidoAtual(pedido)
      const status = pedido.statusPedido.codigo
      if (status >= EnumStatusPedido.FINALIZADOOUENTREGUE) {
        removerPedido()
        return
      }
      setMostrarButton(true);
    }
  }, [getPedidoAtual, removerPedido])

  useEffect(() => {
    handleGetPedidoAtual();
  }, [handleGetPedidoAtual])

  const handleClick = useCallback(() => {
    history.push(`/${empresaId}/pedido/${pedidoAtual?.id}`);
  }, [history, empresaId, pedidoAtual?.id])

  return (
    <Slide direction="down" in={mostrarButton} mountOnEnter unmountOnExit>
      <Box className={classes.container}>
        <Container
          fixed
          maxWidth="md"
        >
          <Box py={2}>
            <Button
              fullWidth
              className={classes.btn}
              classes={{
                root: classes.root,
              }}
              color='inherit'
              onClick={handleClick}
            >
              <Grid container spacing={2} className={classes.gridContainer}>
                <Grid item xs="auto">
                  <Box alignItems="center" display="flex" height="100%">
                    <span className={classes.attentionBall} />
                  </Box>
                </Grid>
                <Grid item xs>
                  <Typography style={{ fontWeight: 700, lineHeight: 1.2 }}>Acompanhar pedido atual</Typography>
                  <Typography variant="caption" color="textSecondary" style={{ fontWeight: 700, lineHeight: 1.2 }}>{pedidoAtual?.statusPedido.descricao}</Typography>
                </Grid>
                <Grid item xs="auto">
                  <ContinuarIcon tipo="BUTTON" />
                </Grid>
              </Grid>
            </Button>
          </Box>
        </Container>
      </Box>
    </Slide>
  );
});

ButtonAcompanharPedido.displayName = 'ButtonAcompanharPedido';
